<template>
  <b-card title="مدیریت ترخیص‌کاران">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="openAdd()"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="نام / شرکت"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="نوع"
                  label-for="IsLegal"
                >
                  <v-select
                    v-model="filterOptions.IsLegal"
                    :options="legalOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="تیک آبی"
                  label-for="IsVerified"
                >
                  <v-select
                    v-model="filterOptions.IsVerified"
                    :options="verifiedOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="openDetails(data.item.Id)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Image)="data">
            <b-avatar
              :src="data.value"
              size="40"
              rounded
            />
          </template>

          <template #cell(FullName)="data">
            <div class="d-flex align-items-center">
              <span>{{ data.item.IsLegal ? data.item.CompanyName : (data.item.Name + ' ' + data.item.Family) }}</span>
              <feather-icon
                v-if="data.item.IsVerified"
                icon="CheckCircleIcon"
                size="16"
                class="ml-50 text-primary"
              />
            </div>
          </template>

          <template #cell(IsLegal)="data">
            <b-badge :variant="data.value ? 'light-info' : 'light-success'">
              {{ data.value ? 'حقوقی' : 'حقیقی' }}
            </b-badge>
          </template>

          <template #cell(CityTitle)="data">
            <span>{{ data.value || '—' }}</span>
          </template>

          <template #cell(Customs)="data">
            <b-badge
              v-if="data.item.AllCustoms"
              variant="light-primary"
            >همه گمرکات</b-badge>
            <span v-else>{{ data.item.CustomsCount }} گمرک</span>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="statusVariant(data.value)">
              {{ statusText(data.value) }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="cursor-pointer"
                @click="openDetails(data.item.Id)"
              />
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer text-danger"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <!-- مدال جزئیات -->
    <b-modal
      v-if="showModal"
      v-model="showModal"
      centered
      hide-footer
      title="جزئیات ترخیص‌کار"
      :no-close-on-backdrop="true"
      size="lg"
    >
      <div
        v-if="detailLoading"
        class="text-center my-3"
      >
        <b-spinner variant="primary" />
      </div>

      <div v-else-if="detail">
        <b-row>
          <b-col
            md="3"
            class="text-center mb-2"
          >
            <b-avatar
              :src="detail.Image"
              size="100"
              rounded
            />
            <div class="mt-1">
              <b-badge :variant="statusVariant(detail.Status)">
                {{ statusText(detail.Status) }}
              </b-badge>
            </div>
            <div class="mt-1">
              <b-badge :variant="detail.IsVerified ? 'primary' : 'secondary'">
                {{ detail.IsVerified ? 'دارای تیک آبی' : 'بدون تیک آبی' }}
              </b-badge>
            </div>
          </b-col>

          <b-col md="9">
            <b-row>
              <b-col
                v-if="!detail.IsLegal"
                md="6"
                class="mb-1"
              >
                <small class="text-muted">نام و نام خانوادگی</small>
                <div class="font-weight-bold">{{ detail.Name }} {{ detail.Family }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">نوع</small>
                <div class="font-weight-bold">{{ detail.IsLegal ? 'حقوقی' : 'حقیقی' }}</div>
              </b-col>

              <b-col
                v-if="!detail.IsLegal"
                md="6"
                class="mb-1"
              >
                <small class="text-muted">کد ملی</small>
                <div class="font-weight-bold">{{ detail.NationalCode || '—' }}</div>
              </b-col>

              <template v-else>
                <b-col
                  md="6"
                  class="mb-1"
                >
                  <small class="text-muted">نام شرکت</small>
                  <div class="font-weight-bold">{{ detail.CompanyName || '—' }}</div>
                </b-col>
                <b-col
                  md="6"
                  class="mb-1"
                >
                  <small class="text-muted">شناسه ملی شرکت</small>
                  <div class="font-weight-bold">{{ detail.CompanyNationalId || '—' }}</div>
                </b-col>
              </template>

              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">موبایل کاربر</small>
                <div class="font-weight-bold">{{ detail.User ? detail.User.Mobile : '—' }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">محل فعالیت</small>
                <div class="font-weight-bold">{{ cityText(detail) }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">سابقه فعالیت</small>
                <div class="font-weight-bold">{{ detail.ExperienceYears ? detail.ExperienceYears + ' سال' : '—' }}</div>
              </b-col>
            </b-row>
          </b-col>

          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">گمرک محل فعالیت</small>
            <div class="mt-25">
              <b-badge
                v-if="detail.AllCustoms"
                variant="light-primary"
              >همه گمرکات</b-badge>
              <template v-else>
                <b-badge
                  v-for="c in detail.Customs"
                  :key="c.CustomsId"
                  variant="light-info"
                  class="mr-50 mb-50"
                >{{ c.Title }}</b-badge>
              </template>
            </div>
          </b-col>

          <b-col
            v-if="detail.AllProductCategory || (detail.Categories && detail.Categories.length)"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">رشته‌های فعالیت</small>
            <div class="mt-25">
              <b-badge
                v-if="detail.AllProductCategory"
                variant="light-primary"
              >همه رشته‌ها</b-badge>
              <template v-else>
                <b-badge
                  v-for="c in detail.Categories"
                  :key="c.ProductCategoryId"
                  variant="light-success"
                  class="mr-50 mb-50"
                >{{ c.Title }}</b-badge>
              </template>
            </div>
          </b-col>

          <b-col
            v-if="detail.Description"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">توضیحات</small>
            <div>{{ detail.Description }}</div>
          </b-col>

          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">مدارک هویتی و گواهی</small>
            <div
              v-if="detail.Documents && detail.Documents.length"
              class="doc-gallery mt-25"
            >
              <a
                v-for="doc in detail.Documents"
                :key="doc.Id"
                :href="doc.File"
                target="_blank"
                class="doc-thumb"
              >
                <img :src="doc.File">
              </a>
            </div>
            <div
              v-else
              class="text-muted"
            >مدرکی بارگذاری نشده است</div>
          </b-col>

          <b-col
            v-if="detail.Status === 2 && detail.RejectReason"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">دلیل رد</small>
            <div class="text-danger">{{ detail.RejectReason }}</div>
          </b-col>
        </b-row>

        <hr>

        <div class="d-flex flex-wrap justify-content-end">
          <b-button
            variant="outline-primary"
            class="mr-1 mb-1"
            @click="openEdit"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-25"
            />
            ویرایش
          </b-button>
          <b-button
            variant="outline-secondary"
            class="mr-1 mb-1"
            @click="toggleVerified"
          >
            <feather-icon
              icon="CheckCircleIcon"
              class="mr-25"
            />
            {{ detail.IsVerified ? 'حذف تیک آبی' : 'اعطای تیک آبی' }}
          </b-button>
          <b-button
            v-if="detail.Status !== 2"
            variant="outline-danger"
            class="mr-1 mb-1"
            @click="openReject"
          >
            رد درخواست
          </b-button>
          <b-button
            v-if="detail.Status !== 1"
            variant="success"
            class="mb-1"
            @click="accept"
          >
            تأیید
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- مدال رد با دلیل -->
    <b-modal
      v-if="showReject"
      v-model="showReject"
      centered
      ok-title="ثبت رد"
      cancel-title="انصراف"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      title="رد درخواست ترخیص‌کار"
      :no-close-on-backdrop="true"
      @ok="reject"
    >
      <b-form-group
        label="دلیل رد (به کاربر نمایش داده می‌شود)"
        label-for="RejectReason"
      >
        <b-form-textarea
          v-model="rejectReason"
          rows="3"
          no-resize
          placeholder="مثلاً مدارک ناقص است…"
        />
      </b-form-group>
    </b-modal>

    <!-- مدال افزودن / ویرایش -->
    <b-modal
      v-if="showForm"
      v-model="showForm"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      :title="form.Id ? 'ویرایش ترخیص‌کار' : 'افزودن ترخیص‌کار'"
      :no-close-on-backdrop="true"
      size="lg"
      @ok.prevent="save"
    >
      <b-row>
        <b-col
          md="3"
          class="text-center mb-2"
        >
          <input
            ref="refImage"
            type="file"
            class="d-none"
            accept="image/*"
            @change="imageRenderer($event)"
          >
          <label style="font-weight: 600; display: block">تصویر</label>
          <div
            class="order-upload mx-auto"
            @click="$refs.refImage.click()"
          >
            <img
              v-if="form.Image"
              :src="form.Image"
            >
            <div v-else>
              <feather-icon
                size="24"
                icon="UploadIcon"
              />
            </div>
          </div>
        </b-col>

        <b-col md="9">
          <b-row>
            <b-col
              v-if="!form.Id"
              md="6"
            >
              <b-form-group
                label="موبایل کاربر"
                label-for="Mobile"
              >
                <b-form-input
                  v-model="form.Mobile"
                  autocomplete="off"
                  placeholder="09xxxxxxxxx"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="نوع"
                label-for="IsLegal"
              >
                <v-select
                  v-model="form.IsLegal"
                  :options="legalOptions"
                  dir="rtl"
                  label="text"
                  :clearable="false"
                  :reduce="x => x.value"
                />
              </b-form-group>
            </b-col>

            <template v-if="!form.IsLegal">
              <b-col md="6">
                <b-form-group
                  label="نام"
                  label-for="Name"
                >
                  <b-form-input
                    v-model="form.Name"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="نام خانوادگی"
                  label-for="Family"
                >
                  <b-form-input
                    v-model="form.Family"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="کد ملی"
                  label-for="NationalCode"
                >
                  <b-form-input
                    v-model="form.NationalCode"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
            </template>

            <template v-else>
              <b-col md="6">
                <b-form-group
                  label="نام شرکت"
                  label-for="CompanyName"
                >
                  <b-form-input
                    v-model="form.CompanyName"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="شناسه ملی شرکت"
                  label-for="CompanyNationalId"
                >
                  <b-form-input
                    v-model="form.CompanyNationalId"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
            </template>

            <b-col md="6">
              <b-form-group
                label="سابقه فعالیت (سال)"
                label-for="ExperienceYears"
              >
                <b-form-input
                  v-model.number="form.ExperienceYears"
                  type="number"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="استان"
            label-for="StateId"
          >
            <z-state
              v-model="form.StateId"
              :clearable="true"
              @input="onStateChange"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="شهر"
            label-for="CityId"
          >
            <v-select
              v-model="form.CityId"
              dir="rtl"
              label="Title"
              :reduce="x => x.Id"
              :options="cityOptions"
              :loading="cityLoading"
              :disabled="!form.StateId"
              :placeholder="form.StateId ? 'انتخاب شهر' : 'ابتدا استان را انتخاب کنید'"
            >
              <span
                slot="no-options"
              >موردی یافت نشد</span>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="فعالیت در همه گمرکات"
            label-for="AllCustoms"
          >
            <v-select
              v-model="form.AllCustoms"
              :options="allCustomsOptions"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="!form.AllCustoms"
          md="6"
        >
          <b-form-group
            label="گمرک محل فعالیت"
            label-for="CustomsId"
          >
            <z-customs
              v-model="form.CustomsId"
              :multiple="true"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="فعالیت در همه رشته‌ها"
            label-for="AllProductCategory"
          >
            <v-select
              v-model="form.AllProductCategory"
              :options="allCustomsOptions"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="!form.AllProductCategory"
          md="6"
        >
          <b-form-group
            label="رشته‌های فعالیت"
            label-for="ProductCategoryId"
          >
            <z-product-category
              v-model="form.ProductCategoryId"
              :multiple="true"
              :clearable="true"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="مدارک هویتی و گواهی (فقط برای بررسی)"
            label-for="Documents"
          >
            <input
              ref="refDocs"
              type="file"
              class="d-none"
              accept="image/*"
              multiple
              @change="docsRenderer($event)"
            >
            <div class="doc-edit-grid">
              <!-- مدارک موجود -->
              <div
                v-for="doc in existingDocuments"
                :key="`e-${doc.Id}`"
                class="doc-edit-item"
              >
                <img :src="doc.File">
                <span
                  class="doc-del"
                  @click="removeExistingDoc(doc.Id)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </span>
              </div>
              <!-- مدارک تازه -->
              <div
                v-for="(src, i) in newDocumentPreviews"
                :key="`n-${i}`"
                class="doc-edit-item new"
              >
                <img :src="src">
                <span
                  class="doc-del"
                  @click="removeNewDoc(i)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </span>
              </div>
              <!-- افزودن -->
              <div
                class="doc-edit-add"
                @click="$refs.refDocs.click()"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="22"
                />
                <span>افزودن</span>
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              v-model="form.Description"
              rows="3"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

import ZCustoms from '@/tools/customs/customs.vue'
import ZState from '@/tools/state.vue'
import ZProductCategory from '@/tools/productcategory.vue'

export default {
  name: 'Agent',
  components: { ZCustoms, ZState, ZProductCategory },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Mobile: null,
        Status: null,
        IsLegal: null,
        IsVerified: null,
        Page: 1,
        PerPage: 10,
      },
      statusOptions: [
        { text: 'در انتظار بررسی', value: 0 },
        { text: 'تأییدشده', value: 1 },
        { text: 'ردشده', value: 2 },
      ],
      legalOptions: [
        { text: 'حقیقی', value: false },
        { text: 'حقوقی', value: true },
      ],
      allCustomsOptions: [
        { text: 'بله', value: true },
        { text: 'خیر', value: false },
      ],
      verifiedOptions: [
        { text: 'دارد', value: true },
        { text: 'ندارد', value: false },
      ],
      showModal: false,
      showReject: false,
      showForm: false,
      form: {},
      detailLoading: false,
      detail: null,
      rejectReason: null,
      cityOptions: [],
      cityLoading: false,
      existingDocuments: [],
      removeDocumentId: [],
      newDocuments: [],
      newDocumentPreviews: [],
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Image', label: 'عکس', thClass: 'col-width-50' },
        { key: 'FullName', label: 'نام / شرکت' },
        { key: 'Mobile', label: 'موبایل' },
        { key: 'IsLegal', label: 'نوع' },
        { key: 'CityTitle', label: 'شهر' },
        { key: 'Customs', label: 'گمرک' },
        { key: 'ExperienceYears', label: 'سابقه' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    statusText(value) {
      return ['در انتظار بررسی', 'تأییدشده', 'ردشده'][value] || '—'
    },
    statusVariant(value) {
      return ['light-warning', 'light-success', 'light-danger'][value] || 'light-secondary'
    },
    cityText(detail) {
      if (!detail || !detail.City) return '—'
      return [detail.City.StateTitle, detail.City.Title].filter(Boolean).join('، ')
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.agent.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetails(id) {
      this.showModal = true
      this.detail = null
      this.detailLoading = true
      this.$http.post(this.$api.agent.get, { Id: id })
        .then(res => {
          this.detail = res.data
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    accept() {
      this.$http.post(this.$api.agent.accept, { Id: this.detail.Id })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    openReject() {
      this.rejectReason = this.detail.RejectReason || null
      this.showReject = true
    },
    reject() {
      this.$http.post(this.$api.agent.reject, { Id: this.detail.Id, RejectReason: this.rejectReason })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    toggleVerified() {
      this.$http.post(this.$api.agent.setverified, { Id: this.detail.Id, IsVerified: !this.detail.IsVerified })
        .then(() => {
          this.detail.IsVerified = !this.detail.IsVerified
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.agent.remove, 'Id', id)
    },
    resetDocs() {
      this.existingDocuments = []
      this.removeDocumentId = []
      this.newDocuments = []
      this.newDocumentPreviews = []
    },
    openAdd() {
      this.form = {
        Mobile: null,
        Name: null,
        Family: null,
        Image: null,
        IsLegal: false,
        NationalCode: null,
        CompanyName: null,
        CompanyNationalId: null,
        StateId: null,
        CityId: null,
        AllCustoms: false,
        CustomsId: [],
        AllProductCategory: false,
        ProductCategoryId: [],
        ExperienceYears: null,
        Description: null,
      }
      this.cityOptions = []
      this.resetDocs()
      this.showForm = true
    },
    openEdit() {
      const d = this.detail
      this.form = {
        Id: d.Id,
        Name: d.Name,
        Family: d.Family,
        Image: d.Image,
        IsLegal: d.IsLegal,
        NationalCode: d.NationalCode,
        CompanyName: d.CompanyName,
        CompanyNationalId: d.CompanyNationalId,
        StateId: d.City ? d.City.StateId : null,
        CityId: d.CityId,
        AllCustoms: d.AllCustoms,
        CustomsId: (d.Customs || []).map(c => c.CustomsId),
        AllProductCategory: d.AllProductCategory,
        ProductCategoryId: (d.Categories || []).map(c => c.ProductCategoryId),
        ExperienceYears: d.ExperienceYears,
        Description: d.Description,
      }
      this.resetDocs()
      this.existingDocuments = (d.Documents || []).slice()
      this.cityOptions = []
      if (this.form.StateId) this.loadCities(this.form.StateId, false)
      this.showModal = false
      this.showForm = true
    },
    loadCities(stateId, reset = true) {
      if (!stateId) {
        this.cityOptions = []
        return
      }
      this.cityLoading = true
      this.$http.post(this.$api.city.getall, { StateId: stateId })
        .then(res => {
          this.cityOptions = res.data
          if (reset) this.form.CityId = null
        })
        .finally(() => {
          this.cityLoading = false
        })
    },
    onStateChange(stateId) {
      this.loadCities(stateId, true)
    },
    docsRenderer(event) {
      const files = Array.from(event.target.files || [])
      files.forEach(file => {
        if (!file.type.startsWith('image/')) return
        this.newDocuments.push(file)
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.newDocumentPreviews.push(reader.result)
        }
      })
      event.target.value = ''
    },
    removeNewDoc(index) {
      this.newDocuments.splice(index, 1)
      this.newDocumentPreviews.splice(index, 1)
    },
    removeExistingDoc(id) {
      this.removeDocumentId.push(id)
      this.existingDocuments = this.existingDocuments.filter(d => d.Id !== id)
    },
    save() {
      const url = this.form.Id ? this.$api.agent.update : this.$api.agent.add

      const formData = new FormData()

      if (this.form.Id) {
        formData.append('Id', this.form.Id)
      } else {
        formData.append('Mobile', this.form.Mobile || '')
      }

      formData.append('IsLegal', this.form.IsLegal)
      formData.append('AllCustoms', this.form.AllCustoms)

      if (this.form.IsLegal) {
        formData.append('CompanyName', this.form.CompanyName || '')
        formData.append('CompanyNationalId', this.form.CompanyNationalId || '')
      } else {
        formData.append('Name', this.form.Name || '')
        formData.append('Family', this.form.Family || '')
        formData.append('NationalCode', this.form.NationalCode || '')
      }

      if (this.form.CityId) {
        formData.append('CityId', this.form.CityId)
      }

      if (this.form.AllCustoms === false && this.form.CustomsId) {
        this.form.CustomsId.forEach(item => {
          formData.append('CustomsId', item)
        })
      }

      formData.append('AllProductCategory', this.form.AllProductCategory)

      if (this.form.AllProductCategory === false && this.form.ProductCategoryId) {
        this.form.ProductCategoryId.forEach(item => {
          formData.append('ProductCategoryId', item)
        })
      }

      this.newDocuments.forEach(file => {
        formData.append('Documents', file)
      })

      this.removeDocumentId.forEach(id => {
        formData.append('RemoveDocumentId', id)
      })

      if (this.form.ExperienceYears) {
        formData.append('ExperienceYears', this.form.ExperienceYears)
      }

      if (this.form.Description) {
        formData.append('Description', this.form.Description)
      }

      const image = this.$refs.refImage.files[0]
      if (image) {
        formData.append('Image', image)
      }

      this.$http.post(url, formData)
        .then(() => {
          this.showForm = false
          this.update()
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])
      fileReader.onload = () => {
        this.$set(this.form, 'Image', fileReader.result)
      }
    },
  },
}
</script>

<style>
.order-upload {
  align-items: center;
  display: flex;
  height: 112px;
  justify-content: center;
  width: 112px;
  text-align: center;
  border: 1px solid #dbdade;
  cursor: pointer;
  border-radius: 0.357rem;
  flex-direction: column;
  margin-bottom: 1rem;
}

.order-upload img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.357rem;
}

.doc-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.doc-thumb {
  display: block;
  width: 90px;
  height: 90px;
  border-radius: 0.357rem;
  overflow: hidden;
  border: 1px solid #dbdade;
}

.doc-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.doc-edit-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.doc-edit-item {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 0.357rem;
  overflow: hidden;
  border: 1px solid #dbdade;
}

.doc-edit-item.new {
  border-color: #7367f0;
}

.doc-edit-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.doc-del {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
}

.doc-edit-add {
  width: 92px;
  height: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1.5px dashed #c3ccd6;
  border-radius: 0.357rem;
  color: #6e6b7b;
  cursor: pointer;
  font-size: 0.8rem;
}

.doc-edit-add:hover {
  border-color: #7367f0;
  color: #7367f0;
}
</style>
